/**
 * 日時の言い方（管理画面のすべての画面で同じ形にする・総点検 J-101）。
 *
 * 「2026年9月23日 16:57」の形にそろえます。画面ごとに「2026/09/23 16:57」と
 * 「2026年9月23日 16:57」が混ざっていると、行き来したときに目立つためです。
 * 時刻は日本時間で出します（お使いになる方の端末の設定に左右されないように）。
 */
const PARTS = new Intl.DateTimeFormat('ja-JP', {
  timeZone: 'Asia/Tokyo',
  year: 'numeric',
  month: 'numeric',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

function partsOf(date: Date): Record<string, string> {
  const out: Record<string, string> = {};
  for (const part of PARTS.formatToParts(date)) out[part.type] = part.value;
  return out;
}

/**
 * 日時を「2026年9月23日 16:57」の形にする。
 * 値が無いときは `empty`（既定は「―」）、読めない値はそのまま出す（画面を壊さない）。
 */
export function formatDateTime(value: string | null | undefined, empty = '―'): string {
  if (value === null || value === undefined || value === '') return empty;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const p = partsOf(date);
  return `${p.year}年${p.month}月${p.day}日 ${p.hour}:${p.minute}`;
}

/** 年を省いた形「9月23日 16:57」（同じ年のうちの短い案内に使う）。 */
export function formatMonthDayTime(value: string | null | undefined, empty = '―'): string {
  if (value === null || value === undefined || value === '') return empty;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const p = partsOf(date);
  return `${p.month}月${p.day}日 ${p.hour}:${p.minute}`;
}

/**
 * 表の中の日時。今年の分は年を省いた「9月23日 16:57」、去年より前は年つきで出す
 * （表の中で幅が足りないときの形・日本語監査の統一表／総点検 M6）。
 */
export function formatTableDateTime(value: string | null | undefined, empty = '―'): string {
  if (value === null || value === undefined || value === '') return empty;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return value;
  const sameYear = partsOf(date).year === partsOf(new Date()).year;
  return sameYear ? formatMonthDayTime(value, empty) : formatDateTime(value, empty);
}
